import { createAdConfig } from '@/utils/adUtil'

export const appAdConfig = {}

appAdConfig.AD_SIZES = {
  SP_ATF: [
    [320, 100],
    [320, 50]
  ],
  SP_BTF_1: [
    [320, 100],
    [320, 50]
  ],
  SP_BTF_2: [
    [200, 200],
    [320, 100],
    [320, 250],
    [336, 280],
    [320, 50],
    [1, 1],
    [300, 250],
    [320, 180]
  ],
  SP_BTF_4_SMALL_HEIGHT: [
    [320, 100],
    [320, 50]
  ],
  SP_BTM: [
    [320, 180],
    [320, 250],
    [336, 280],
    [320, 50],
    [320, 100],
    [200, 200],
    [300, 250]
  ],
  STICKY: [320, 50]

}

appAdConfig.gpt_conf = [
  createAdConfig('Onebox_world_atf_sp', appAdConfig.AD_SIZES.SP_ATF, 'ads-atf', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf1_sp', appAdConfig.AD_SIZES.SP_BTF_1, 'ads-btf1-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf1_sp', appAdConfig.AD_SIZES.SP_BTF_1, 'ads-btf1-sp-small-height', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf2_sp', appAdConfig.AD_SIZES.SP_BTF_2, 'ads-btf2-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf4_sp', appAdConfig.AD_SIZES.SP_BTF_4_SMALL_HEIGHT, 'ads-btf4-sp-small-height', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btm_sp', appAdConfig.AD_SIZES.SP_BTM, 'ads-btm', 'DATA', false, 'sp'),
  createAdConfig('Onebox_sticky_ad', appAdConfig.AD_SIZES.STICKY, 'div-gpt-ad-sticky', 'DATA', true, 'sp', true)
]
